import { useState, useEffect } from "react";
import {
  onSnapshot,
  collection,
  query,
  orderBy,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../firebase";

const DiscoveredMaterialsViewer = () => {
  const [materials, setMaterials] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({
    name: "",
    description: "",
    quality: "",
    rarity: "",
  });
  const [filters, setFilters] = useState({
    rarity: "",
    quality: "",
  });

  useEffect(() => {
    const q = query(
      collection(db, "discoveredMaterials"),
      orderBy("createdAt", "desc")
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const loadedMaterials = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMaterials(loadedMaterials);
    });

    return () => unsubscribe();
  }, []);

  const startEditing = (material) => {
    setEditingId(material.id);
    setEditForm({
      name: material.name,
      description: material.description,
      quality: material.quality,
      rarity: material.rarity,
    });
  };

  const cancelEditing = () => {
    setEditingId(null);
    setEditForm({
      name: "",
      description: "",
      quality: "",
      rarity: "",
    });
  };

  const saveEditing = async (id) => {
    const docRef = doc(db, "discoveredMaterials", id);
    await updateDoc(docRef, {
      name: editForm.name,
      description: editForm.description,
      quality: editForm.quality,
      rarity: editForm.rarity,
    });
    console.log("✅ Material updated in Firestore");
    cancelEditing();
  };

  const deleteMaterial = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this material?"
    );
    if (confirmDelete) {
      await deleteDoc(doc(db, "discoveredMaterials", id));
      console.log("🗑️ Material deleted from Firestore");
    }
  };

  const handleInputChange = (e) => {
    setEditForm({
      ...editForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  const filteredMaterials = materials.filter((material) => {
    const matchesRarity = filters.rarity
      ? material.rarity === filters.rarity
      : true;
    const matchesQuality = filters.quality
      ? material.quality === filters.quality
      : true;
    return matchesRarity && matchesQuality;
  });

  return (
    <div>
      <div style={{ marginBottom: "1rem", display: "flex", gap: "1rem" }}>
        <select
          name="rarity"
          value={filters.rarity}
          onChange={handleFilterChange}
        >
          <option value="">All Rarities</option>
          <option value="Common">Common</option>
          <option value="Uncommon">Uncommon</option>
          <option value="Rare">Rare</option>
          <option value="Legendary">Legendary</option>
          <option value="Celestial">Celestial</option>
        </select>

        <select
          name="quality"
          value={filters.quality}
          onChange={handleFilterChange}
        >
          <option value="">All Qualities</option>
          <option value="Poor">Poor</option>
          <option value="Good">Good</option>
          <option value="Reliable">Reliable</option>
          <option value="Finest">Finest</option>
          <option value="Impeccable">Impeccable</option>
        </select>
      </div>

      {filteredMaterials.map((material) => (
        <div
          key={material.id}
          style={{
            border: "1px solid #ccc",
            padding: "1rem",
            margin: "1rem 0",
            borderRadius: "8px",
          }}
        >
          {editingId === material.id ? (
            <>
              <input
                type="text"
                name="name"
                value={editForm.name}
                onChange={handleInputChange}
                placeholder="Material Name"
              />
              <textarea
                name="description"
                value={editForm.description}
                onChange={handleInputChange}
                placeholder="Material Description"
              />
              <input
                type="text"
                name="quality"
                value={editForm.quality}
                onChange={handleInputChange}
                placeholder="Quality"
              />
              <input
                type="text"
                name="rarity"
                value={editForm.rarity}
                onChange={handleInputChange}
                placeholder="Rarity"
              />
              <div style={{ marginTop: "0.5rem" }}>
                <button onClick={() => saveEditing(material.id)}>
                  Save ✅
                </button>
                <button
                  onClick={cancelEditing}
                  style={{ marginLeft: "0.5rem" }}
                >
                  Cancel ❌
                </button>
              </div>
            </>
          ) : (
            <>
              <h3>{material.name}</h3>
              <p>{material.description}</p>
              <p>
                <strong>Quality:</strong> {material.quality}
              </p>
              <p>
                <strong>Rarity:</strong> {material.rarity}
              </p>
              <div style={{ marginTop: "0.5rem" }}>
                <button onClick={() => startEditing(material)}>Edit ✏️</button>
                <button
                  onClick={() => deleteMaterial(material.id)}
                  style={{ marginLeft: "0.5rem", color: "red" }}
                >
                  Delete 🗑️
                </button>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default DiscoveredMaterialsViewer;
